/**
 * 
 */

import React, { useEffect, useState }                                from 'react'
import axios                                                         from 'axios'
import {
   addClassNoteOptions,
   CLIENT_PUBLIC_TOKEN,
   crudClassNoteOptions
}                                                                    from '../../config'
import ClassNoteCreate                                               from '../Components/ClassNoteCreate'
import { Container, Grid }                                           from '@material-ui/core'
import { getTPSClassesFromNodeServer, node_server }                  from '../../Helpers'
import MySelect                                                      from '../../Components/MySelect'
import Typography                                                    from '@material-ui/core/Typography'

const ClassNote = () => {

   const   pageTitle                            =  'Admin - Main Notes Page'
   
   const [ noteCount,      setNoteCount      ]  =  useState(-1)
   const [ selection,      setSelection      ]  =  useState('')
   const [ tpsClass,       setTpsClass       ]  =  useState('')
   const [ tpsClasses,     setTpsClasses     ]  =  useState([])

   /* 
   * Item 1.
   * This used to call the PHP server and gets a list of all the TPS Classes from tbl_class_page.
   * It now calls the Noder Server and does the same thing.
   */
   useEffect( () => {
      getTPSClassesFromNodeServer()
         .then( classes => setTpsClasses(classes) )
         .catch( (error) => {
            console.error(error)
         } )
   }, [] )

   /* 
   * Item 2. and Item 4.
   * Sent down to <ClassDropdown /> which sends back a String containing the selected TPS Class
   */
   const selectedOption = (e) => {
      if (e.target.value === 'Add Class Note') {
         setSelection(e.target.value)
      }
      else {
         setTpsClass(e.target.value)
      }
   }

   /* 
   * Item 3.
   * Take TPS Class from <MySelect /> and check the MongoDB to see if an entry exists or not
   */
   useEffect( () => {
      if( tpsClass !== '' ){
         axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
         axios.get(node_server + `classNote/GetClassNote/${tpsClass}`)
               .then( res => res.data )
               .then( data => {
                  if( data ){
                     setNoteCount(data.noteCount)
                  }
               } )
               .catch( (error) => {
                  console.error('There was an error on GET class note', error)
               } )
      }
   }, [tpsClass] )

   return(
      <Container style={{marginTop: '5rem'}} >

         <Grid>
            <Typography variant='h4' style={{marginBottom: '0rem'}} >
               { pageTitle }
            </Typography>
         </Grid>

         <Container>
            <MySelect label="Select a Class" name="classNoteTpsClassSelection" options={tpsClasses} selectedOption={selectedOption} />
         </Container>

         {noteCount === 0
            ?
               <Container>
                  <MySelect label="Select Note Option" name="classNoteOption" options={addClassNoteOptions} selectedOption={selectedOption} />
               </Container>
            :
               null
         }
         {noteCount > 0
            ?
               <Container>
                  <MySelect label="Select Note Option" name="classNoteOption" options={crudClassNoteOptions} selectedOption={selectedOption} />
               </Container>
            :
               null
         }

         {  selection === 'Add Class Note'
            ?
               <ClassNoteCreate noteCount={noteCount} tpsClass={tpsClass} />
            :
               null
         }

         {/* Available Options given a GET ClassNote for the selected class */}

         {/* Available Options if the class has no Class Note: Add Class Note */}

         {/* Available Options if the class has no Class Note: Add Class Note, Delete Class Note, Edit Class Note, Update Class Note */}

         {/* Show the Component for the selected CRUD option */}

      </Container>
   )
}

export default ClassNote